var exports = {
  "n": "xe533113f--381642--link",
};

module.exports = exports;
